// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes, render } from '@plesk/ui-library';
import Status from './Status';
import Pathbar from './Pathbar';
import { Router } from 'react-router-dom';

const renderTitle = title => {
    const parts = document.title.split(' - ');

    const [documentTitle] = $$('title');
    if (documentTitle) {
        documentTitle.update(
            title ? `${title.stripTags()} - ${parts[parts.length - 1]}` : `${parts[parts.length - 1]}`
        );
    }

    const [pageTitle] = $$('.heading-area > h2 > span');
    if (pageTitle) {
        pageTitle.update(title);
    }
};

const renderPathbar = (breadcrumbs, history) => {
    const items = breadcrumbs.slice(0, breadcrumbs.length - 1).map(item => {
        item.title = item.title.stripTags();

        return item;
    });

    if (!document.getElementById('pathbar-wrapper')) {
        const [pageContent] = $$('.page-content,.page-simplified__content');
        pageContent.insert({
            top: '<div id="pathbar-wrapper"></div>',
        });
    }

    render(
        items.length > 0
            ? <Router history={history}><Pathbar items={items} /></Router>
            : <div />,
        document.getElementById('pathbar-wrapper')
    );
};

const renderBottomAnchor = () => {
    const bottomAnchor = $('bottomAnchor');

    if (bottomAnchor) {
        bottomAnchor.innerHTML = new Date().getTime();
    }
};

const PageContent = ({
    title,
    breadcrumbs,
    statusMessages,
    children,
}, {
    router,
}) => {
    renderTitle(title);
    renderPathbar(breadcrumbs, router.history);
    renderBottomAnchor();

    return (
        <div>
            <Status messages={statusMessages} />
            {children}
        </div>
    );
};

PageContent.propTypes = {
    title: PropTypes.string.isRequired,
    statusMessages: PropTypes.array.isRequired,
    breadcrumbs: PropTypes.array.isRequired,
    children: PropTypes.element.isRequired,
};

PageContent.contextTypes = {
    router: PropTypes.object,
};

export default PageContent;



// WEBPACK FOOTER //
// ./plesk/PageContent.js